import { render, staticRenderFns } from "./SmartPointWidget.vue?vue&type=template&id=3a865874"
import script from "./SmartPointWidget.vue?vue&type=script&lang=js"
export * from "./SmartPointWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports